import FilterMenu from './filter-menu';

export default FilterMenu;
